import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const privacyBlocks = [
  {
    title: "1. Responsable del tratamiento",
    content:
      "SUIVOS, S.A. de C.V. es responsable del tratamiento de los datos personales recabados a través de Metal Concrete.",
  },
  {
    title: "2. Información que recopilamos",
    content:
      "Recopilamos datos de cuenta y operación, como nombre, email, teléfono, propiedades publicadas, solicitudes, historial de suscripción y actividad dentro de la plataforma.",
  },
  {
    title: "3. Finalidades del tratamiento",
    content:
      "Usamos tus datos para crear y administrar tu cuenta, operar funcionalidades inmobiliarias, procesar pagos, prevenir fraude, cumplir obligaciones legales, dar soporte y validar elegibilidad de beneficios comerciales como períodos de prueba.",
  },
  {
    title: "4. Transferencias y terceros",
    content:
      "Para prestar el servicio integramos proveedores como Stripe (pagos), Resend (emails) y Mapbox (mapas). Adicionalmente, cuando un usuario publica una Solicitud de Búsqueda, sus datos de contacto (nombre, email y teléfono) pueden compartirse con otros usuarios registrados que respondan dicha solicitud, exclusivamente para facilitar la operación solicitada. Estas transferencias se limitan a lo necesario para la operación. No vendemos datos personales.",
  },
  {
    title: "5. Conservación y seguridad",
    content:
      "Aplicamos medidas técnicas y administrativas razonables para proteger la información. Conservamos datos por el tiempo necesario para operación, cumplimiento legal y atención de controversias.",
  },
  {
    title: "6. Derechos ARCO y revocación",
    content:
      "Puedes solicitar acceso, rectificación, cancelación u oposición (ARCO), así como revocar tu consentimiento cuando sea legalmente procedente.",
  },
  {
    title: "7. Cambios al aviso",
    content:
      "Podemos actualizar este aviso para reflejar cambios legales u operativos. La versión publicada en esta página será la vigente.",
  },
];

const Privacy = () => {
  return (
    <div className="min-h-screen bg-muted/20">
      <Header />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 md:py-14">
        <section className="rounded-2xl border border-border bg-background p-6 sm:p-8 md:p-10 shadow-sm">
          <p className="text-xs uppercase tracking-[0.18em] text-primary font-semibold mb-3">
            Legal
          </p>
          <h1
            className="text-3xl sm:text-4xl font-bold text-foreground"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            Aviso de Privacidad
          </h1>
          <p className="text-sm sm:text-base text-muted-foreground mt-4 max-w-3xl">
            Este aviso describe cómo SUIVOS, S.A. de C.V. recopila, usa, protege
            y, en su caso, comparte la información de los usuarios de Metal
            Concrete.
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
            {privacyBlocks.map((block) => (
              <article
                key={block.title}
                className="rounded-xl border border-border bg-muted/30 p-4 sm:p-5"
              >
                <h2 className="text-base sm:text-lg font-semibold text-foreground">
                  {block.title}
                </h2>
                <p className="mt-2 text-sm sm:text-[15px] text-muted-foreground leading-relaxed">
                  {block.content}
                </p>
              </article>
            ))}
          </div>

          <section className="mt-6 rounded-xl border border-border bg-background p-4 sm:p-5">
            <h2 className="text-base sm:text-lg font-semibold text-foreground">
              Contacto para temas de privacidad
            </h2>
            <p className="mt-2 text-sm sm:text-[15px] text-muted-foreground leading-relaxed">
              Responsable: SUIVOS, S.A. de C.V. Para ejercer derechos ARCO o
            consultas de privacidad, escríbenos a{" "}
              <a
                href="mailto:soporte@metalconcrete.com"
                className="text-primary hover:underline"
              >
                soporte@metalconcrete.com
              </a>
              .
            </p>
          </section>

          <p className="text-xs text-muted-foreground mt-8 pt-5 border-t border-border">
            Última actualización: 26 de abril de 2026
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Privacy;
